import Swiper, { Navigation, Lazy, Pagination } from "swiper";


const singleProduct = {

  init() {
    singleProduct.productGallerySlider();
    singleProduct.events();
  },

  events() {
    // Increment quantity
    $('.open-product__count-action.add').on('click', function () {
      var currentQuantity = parseInt($('input[name="quantity"]').val());
      var maxQuantity = 20;

      if (currentQuantity < maxQuantity) {
        $('input[name="quantity"]').val(currentQuantity + 1);
      }
    });

    // Decrement quantity
    $('.open-product__count-action.minus').on('click', function () {
      var currentQuantity = parseInt($('input[name="quantity"]').val());
      var minQuantity = 1;

      if (currentQuantity > minQuantity) {
        $('input[name="quantity"]').val(currentQuantity - 1);
      }
    });

    // Buy now  button functionality
    $('.open-product__btn-buy').on('click', function (e) {
      e.preventDefault();

      // Get the product quantity
      let quantity = parseInt($('input[name="quantity"]').val());
      const prod_id = parseInt($('.open-product__btn-buy').data('id'));
      const checkout_url = $('.open-product__btn-buy').data('checkout');

      // Add the product to the cart using AJAX and redirect to checkout
      $.ajax({
        type: 'POST',
        url: ajaxurl,
        data: {
          action: 'add_to_cart',
          product_id: prod_id,
          quantity: quantity,
        }
      })
        .done((response) => {
          if (response.success) {
            window.location.href = checkout_url;
          }
        });
    });
  },
  productGallerySlider() {
    const wrapEl = $(".open-product");
    if (!wrapEl.length) {
      return;
    }

    const swiper = new Swiper(wrapEl.find(".gallery-slider")[0], {
      modules: [Lazy, Navigation, Pagination],
      loop: true,
      slidesPerView: 1,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 3,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },

      navigation: {
        prevEl: wrapEl.find(".open-product__slider-nav-prev")[0],
        nextEl: wrapEl.find(".open-product__slider-nav-next")[0],
      },
    });
  },
}

export default singleProduct;
